module.exports = __webpack_public_path__ + "img/old_first-divider.c6e68f94.png";